import { faArrowUpRight } from "@fortawesome/pro-light-svg-icons";
import { faAdd, faEye, faList } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Button, Stack } from "@vapor/react-material";
import { useTranslation } from "react-i18next";
import { FulfilmentStatus } from "../../../core/api/use-get-fulfilment-detail/FulfilmentStatus";
import { Can } from "../../../core/permissions/Can";

interface FulfilmentDetailCTAOptionsProps {
    fulfilmentStatus?: FulfilmentStatus;
    handleOnClickGoToTaxPayerFulfilments?: () => void;
    handleOnClickAddActivity?: () => void;
    handleOnClickPreviewModel?: () => void;
    handleOnClickGoToProcedure?: () => void;
}

export const FulfilmentDetailCTAOptions = ({
    fulfilmentStatus,
    handleOnClickGoToTaxPayerFulfilments,
    handleOnClickAddActivity,
    handleOnClickPreviewModel,
    handleOnClickGoToProcedure,
}: FulfilmentDetailCTAOptionsProps) => {
    const { t } = useTranslation();

    const isAddActivityEnabled = () => {
        return (
            handleOnClickAddActivity &&
            fulfilmentStatus !== FulfilmentStatus.COMPLETED
        );
    };
    return (
        <Stack
            direction="column"
            spacing={2}
            alignItems="flex-start"
            marginLeft={4}
        >
            <Button
                color="primary"
                disabled={!handleOnClickGoToTaxPayerFulfilments}
                onClick={handleOnClickGoToTaxPayerFulfilments}
            >
                <FontAwesomeIcon icon={faList} />
                <Typography fontSize="titleMedium" marginLeft={2}>
                    {t(
                        "views.fulfilment_detail.components.fulfilment_detail.activity.cta.taxpayer_fulfilments",
                    )}
                </Typography>
            </Button>
            <Can policy="activityManage">
                <Button
                    color="primary"
                    disabled={!isAddActivityEnabled()}
                    onClick={handleOnClickAddActivity}
                >
                    <FontAwesomeIcon icon={faAdd} />
                    <Typography fontSize="titleMedium" marginLeft={2}>
                        {t(
                            "views.fulfilment_detail.components.fulfilment_detail.activity.cta.add_activity_manually",
                        )}
                    </Typography>
                </Button>
            </Can>
            <Button
                color="primary"
                disabled={!handleOnClickPreviewModel}
                onClick={handleOnClickPreviewModel}
            >
                <FontAwesomeIcon icon={faEye} />
                <Typography fontSize="titleMedium" marginLeft={2}>
                    {t(
                        "views.fulfilment_detail.components.fulfilment_detail.activity.cta.preview_model",
                    )}
                </Typography>
            </Button>
            <Button
                color="primary"
                disabled={!handleOnClickGoToProcedure}
                onClick={handleOnClickGoToProcedure}
            >
                <FontAwesomeIcon icon={faArrowUpRight} />
                <Typography fontSize="titleMedium" marginLeft={2}>
                    {t(
                        "views.fulfilment_detail.components.fulfilment_detail.activity.cta.go_to_procedure",
                    )}
                </Typography>
            </Button>
        </Stack>
    );
};
